import {NgModule} from '@angular/core';

import {PrimaryTopicModalComponent} from './index';
import {IonicModule} from 'ionic-angular';
import {TreeListModule} from '../../../tree/tree-list/tree-list.component.module';

/**
 * Module for the PrimaryTopicModalModule
 * @class
 */
@NgModule({
  declarations: [PrimaryTopicModalComponent],
  entryComponents: [PrimaryTopicModalComponent],
  exports: [PrimaryTopicModalComponent],
  imports: [
    IonicModule,
    TreeListModule,
  ],
  providers: [],
})
export class PrimaryTopicModalModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/components/metadata-menu/topic/primary-topic-modal/primary-topic-modal.component.module.ts